import IconBlockSection from './icon-block-section';

export default IconBlockSection;
